"use client"

import { Spinner } from "@/components/ui/spinner";

import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import type { CSSProperties } from "react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

type SonnerStyle = CSSProperties & {
  "--normal-bg": string
  "--normal-text": string
  "--normal-border": string
  "--border-radius": string
}

const sonnerStyle: SonnerStyle = {
  "--normal-bg": "var(--popover)",
  "--normal-text": "var(--popover-foreground)",
  "--normal-border": "var(--border)",
  "--border-radius": "var(--radius)",
}

const Toaster = ({ theme = "light", ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Spinner />,
      }}
      style={sonnerStyle}
      toastOptions={{
        classNames: {
          toast: "border shadow-sm",
          title: "font-medium",
          description: "opacity-85",
          icon: "text-current",
          success: "border-emerald-300 bg-emerald-50 text-emerald-950",
          info: "border-blue-300 bg-blue-50 text-blue-950",
          warning: "border-amber-300 bg-amber-50 text-amber-950",
          error: "border-red-300 bg-red-50 text-red-950",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
